import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./store";
import ScrollToTop from "./scrollToTop";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { ToastContainer, toast } from "react-toastify";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <GoogleOAuthProvider
    clientId={
      process.env.REACT_APP_GOOGLE_CLIENT_ID == undefined
        ? ""
        : process.env.REACT_APP_GOOGLE_CLIENT_ID
    }
  >
    <Provider store={store}>
      <BrowserRouter>
        <ScrollToTop />
        <App />
        <ToastContainer position="bottom-left" theme="dark" autoClose={5000} />
      </BrowserRouter>
    </Provider>
  </GoogleOAuthProvider>
);
